export interface StorageDriver {
  read(key: string): string | null;
  write(key: string, value: string): void;
}

export class LocalStorageDriver implements StorageDriver {
  constructor(private readonly storage: Pick<Storage, "getItem" | "setItem">) {}

  read(key: string): string | null {
    return this.storage.getItem(key);
  }

  write(key: string, value: string): void {
    this.storage.setItem(key, value);
  }
}
